/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

import * as ActionTypes from './actionTypes';

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setErrorList = (payload) => ({
  type: ActionTypes.ERROR_LIST_TDP,
  payload,
});
export const setCheckNumber = (payload) => ({
  type: ActionTypes.CHECK_NUMBER_TDP,
  payload,
});

export const setTotalDollarsPaidGrid = (data) => ({
  type: ActionTypes.SET_TOTAL_DOLLER_PAID_REPORT,
  payload: data,
});

export const refreshTotalDollarsPaid = () => ({
  type: ActionTypes.REFRESH_TOTAL_DOLLER_PAID,
  payload: {},
});

export const getTotalDollerPaidReport = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_TOTAL_DOLLARS_PAID_REPORT_GRID}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(
        setTotalDollarsPaidGrid(response?.data?.totalDollarsPaidReportVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setTotalDollarsPaidGrid([]));
    });
};
